{{#each allInstanceVariablesWithGetter}}
virtual function {{ rootType }} {{ getterName }}();
  return {{ identifier }};
endfunction

{{/each}}
